import React, { useContext } from 'react';

import BpTracking from '../../utils/bpTracking';
import { customTemplateProps } from '../../utils/interface';
import translations from '../../utils/translations';
import CustomCTAButton from '../common/CustomCTAButton';
import ImageModal from '../common/ImageModal';
import SecondaryCTAButton from '../common/SecondaryCTAButton';
import TrackingContext from '../common/TrackingContext';

const DEFAULT_TEXT = translations.upgrade;
const DEFAULT_URL = '/upgrade';

interface Props {
  modalConfig?: customTemplateProps;
  onClose: VoidFunction;
}

const CustomModal = (props: Props) => {
  const trackingProps = useContext(TrackingContext);

  const buttonText = props.modalConfig?.primaryCTAText
    ? props.modalConfig.primaryCTAText
    : DEFAULT_TEXT;
  const buttonLink = props.modalConfig?.primaryCTALink
    ? props.modalConfig.primaryCTALink
    : DEFAULT_URL;

  return (
    <ImageModal
      dataTestId="feature-upsell-container"
      headerText={props.modalConfig?.headerText}
      subHeaderText={props.modalConfig?.subHeaderText}
      imgSrc={props.modalConfig?.imgSrc}
      onClose={props.onClose}
      body={props.modalConfig?.body}
      footer={
        <>
          <CustomCTAButton
            text={buttonText}
            link={buttonLink}
            variant="upsell"
            onClick={() => {
              BpTracking.trackButtonClick(
                {
                  ...trackingProps.params,
                  copy: buttonText,
                  path: window.location.href,
                  target_path: buttonLink,
                  target: window.location.pathname,
                  device_type: trackingProps.device_type,
                },
                trackingProps.bpEventVersion,
              );

              if (trackingProps.onButtonClick) {
                trackingProps.onButtonClick({
                  copy: buttonText,
                  target_path: buttonLink,
                });
              }
            }}
          />
          {props.modalConfig?.secondaryCTAText && props.modalConfig?.secondaryCTALink && (
            <SecondaryCTAButton
              text={props.modalConfig.secondaryCTAText}
              link={props.modalConfig.secondaryCTALink}
            />
          )}
        </>
      }
    />
  );
};

export default CustomModal;
